/* tslint:disable */

declare var Object: any;
export interface SFLeaveRequestInterface {
  "id"?: number;
}

export class SFLeaveRequest implements SFLeaveRequestInterface {
  "id": number;
  constructor(data?: SFLeaveRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFLeaveRequest`.
   */
  public static getModelName() {
    return "SFLeaveRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFLeaveRequest for dynamic purposes.
  **/
  public static factory(data: SFLeaveRequestInterface): SFLeaveRequest{
    return new SFLeaveRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFLeaveRequest',
      plural: 'SFLeaveRequests',
      path: 'SFLeaveRequests',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFLeaveRequest.ts